import { BankEntity } from 'models/BankEntity';
import { CompanyEntity } from 'models/CompanyEntity';
import { ActionType, getType } from 'typesafe-actions';

import { DebtInstrumentType } from '../../../enums';

import * as debtPricerActions from '../../actions';

type DebtPricerActionType = ActionType<typeof debtPricerActions>;

export type TradeSummaryState = {
  debt_instrument_type_id: null | DebtInstrumentType;
  company_entity_id: CompanyEntity['id'];
  bank_entity_id: BankEntity['bank_entity_id'];
  debt_commercial_type_id: null | number;
  description: null | string;
  creator_id: null | string;
};

export const TradeSummaryInitialState: TradeSummaryState = {
  debt_instrument_type_id: null,
  company_entity_id: '553908a6dd71e',
  bank_entity_id: '59db93650f019',
  debt_commercial_type_id: 1,
  description: null,
  creator_id: null,
};

const tradeSummaryReducer = (
  state: TradeSummaryState = TradeSummaryInitialState,
  action: DebtPricerActionType,
): TradeSummaryState => {
  switch (action.type) {
    case getType(debtPricerActions.setDebtInstrument):
      return {
        ...state,
        debt_instrument_type_id: action.payload.debt_instrument_type_id,
      };

    default:
      return state;
  }
};

export default tradeSummaryReducer;
